import { api } from './apiRoutes';
import instance from './axiosConfig';
import { checkTokenExpire } from './common_function';

export const POST = async (url: string, data?: object) => {
  return await instance.post(url, data);
};
export const GET = async (url: string) => {
  return await instance.get(url);
};
export const PUT = async (url: string, data?: object) => {
  return await instance.put(url, data);
};
export const DELETE = async (url: string, data?: object) => {
  return await instance.delete(url, {
    data,
  });
};
export const postFile = async (file: File | FormData) => {
  return await instance.post(api.upload, file, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};
export const uploadFile = async (
  file: File,
  source: string,
  token: string,
  refresh: string,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', file.name);
  formData.append('source', source);
  const checkToken = await checkTokenExpire(token, refresh);
  const new_token = checkToken ? checkToken : token;
  const res = await fetch(api.upload, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + new_token,
    },
    body: formData,
  });
  return res.json();
};
